import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createCaptureCasingProfile, deleteCaptureCasingProfile, getCaptureCasingProfiles, updateCaptureCasingProfile } from "../../api/captures/casingProfile";
import { CasingProfileForm } from "../../types/forms/capture";

export const useCaptureCasingProfile = (captureIdStr?: string) => {
  const queryClient = useQueryClient();
  const captureId = Number(captureIdStr);

  const queryKey = ["capture", captureId, "casing-profile"];

  const result = useQuery({
    queryKey,
    queryFn: () => getCaptureCasingProfiles(captureId),
    enabled: !!captureId,
  });

  const createMutation = useMutation({
    mutationFn: (values: CasingProfileForm) => createCaptureCasingProfile(captureId, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  const updateMutation = useMutation({
    mutationFn: ({ profileId, values }: { profileId: number; values: CasingProfileForm }) => updateCaptureCasingProfile(captureId, profileId, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  const deleteMutation = useMutation({
    mutationFn: (profileId: number) => deleteCaptureCasingProfile(captureId, profileId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  return {
    casingProfilesData: result.data ?? [],
    isPending: result.isPending,
    isError: result.isError,
    error: result.error,
    createCasingProfile: createMutation.mutateAsync,
    updateCasingProfile: updateMutation.mutateAsync,
    deleteCasingProfile: deleteMutation.mutateAsync,
    isUpdating: createMutation.isPending || updateMutation.isPending || deleteMutation.isPending,
  };
};
